import React from "react";
import PropTypes from "prop-types";
import countryList from "iso-3166-country-list";
import { Select, FormControl, FormHelperText } from "@material-ui/core";

import useStyles from "./useStyles";

const CountrySelect = (props) => {
  const { error, value, onChange } = props;
  const classes = useStyles();

  return (
    <FormControl error={error} className={classes.formControl}>
      <Select
        inputProps={{
          "data-recurly": "country",
        }}
        variant="outlined"
        native
        onChange={onChange}
        value={value}
        id="country"
      >
        {countryList.map(({ code, name }) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </Select>
      {error && <FormHelperText error>Invalid Country</FormHelperText>}
    </FormControl>
  );
};

CountrySelect.propTypes = {
  error: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CountrySelect;
